import { FormControlLabel, Radio } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Form } from "formik";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import CustomDialog from "../../../../../commons/dialog/customDialog";
import FormikActions from "../../../../../commons/formik/formikActions";
import FormikForm from "../../../../../commons/formik/formikForm";
import FormikRadio from "../../../../../commons/formik/formikRadio";
import CircularLoading from "../../../../../commons/loadingData/circularLoading";
import { StyledSignForm } from "../../../../../styled/accident";

const validation = Yup.object({
  marcaFirmado: Yup.string().required("Campo obligatorio"),
  firmaConforme: Yup.string().required("Campo obligatorio"),
});

const SignForm = ({
  open,
  handleClose,
  handleSubmit,
  document,
  handleConfirmClose,
}) => {
  const postSignForm = useSelector((state) => state.forms.postSignForm);

  const signFormModel = {
    marcaFirmado: document.marcaFirmado ? "Si" : "No",
    firmaConforme: document.firmaConforme || "",
  };

  return (
    <CustomDialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Firma del trabajador</DialogTitle>
      {postSignForm.isFetching ? (
        <StyledSignForm.LoadingContainer>
          <CircularLoading />
        </StyledSignForm.LoadingContainer>
      ) : (
        <FormikForm
          initialValues={signFormModel}
          validationSchema={validation}
          onSubmit={(values) => {
            handleSubmit(values);
          }}>
          {(props) => (
            <Form>

              <DialogContent>
                <StyledSignForm.RowContainer>
                  <FormikRadio
                    name="marcaFirmado"
                    value={signFormModel.marcaFirmado}
                    label="¿El trabajador firmó el documento?"
                    row>
                    <FormControlLabel
                      value="Si"
                      control={<Radio />}
                      label="Si"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                      labelPlacement="end"
                    />
                  </FormikRadio>
                </StyledSignForm.RowContainer>
                {props.values.marcaFirmado === "Si" && (
                  <StyledSignForm.RowContainer>
                    <FormikRadio
                      name="firmaConforme"
                      value={signFormModel.firmaConforme}
                      label="¿El trabajador firmó en conformidad?"
                      row>
                      <FormControlLabel
                        value="C"
                        control={<Radio />}
                        label="Si"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="D"
                        control={<Radio />}
                        label="No"
                        labelPlacement="end"
                      />
                    </FormikRadio>
                  </StyledSignForm.RowContainer>
                )}
              </DialogContent>
              <DialogActions>
                <FormikActions handleCancel={handleConfirmClose} />
              </DialogActions>
            </Form>
          )}
        </FormikForm>
      )}
    </CustomDialog>
  );
};

export default SignForm;
